import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFrasesSeleccionAplicacionThunk } from "../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.thunks";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import Pagination from "../components/UI/Pagination";
import {
  clearFrasesSeleccionAplicacionError,
  setPage,
} from "../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.reducer";
import EmptyState from "./UI/EmptyState";
import { Icon } from "@iconify/react";
import FrasesSeleccionAplicacionHeader from "./phases-application/PhrasesApplicationHeader";
import FrasesSeleccionAplicacionTable from "./phases-application/FrasesSeleccionAplicacionTable";
import FraseSeleccionAplicacionViewModal from "./phases-application/FraseSeleccionAplicacionViewModal";
import FraseSeleccionAplicacionFormModal from "./phases-application/FraseSeleccionAplicacionFormModal";
import ConfirmToggleSeleccionAplicacionModal from "./phases-application/ConfirmToggleSeleccionAplicacionModal";

const FrasesSeleccionAplicacionListLayer = () => {
  const dispatch = useDispatch();
  const { list, loading, error, page, pageSize, search, count } = useSelector(
    (state) => state.frasesSeleccionAplicacion,
  );

  useEffect(() => {
    dispatch(getFrasesSeleccionAplicacionThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesSeleccionAplicacionHeader />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearFrasesSeleccionAplicacionError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando frases..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {list.length === 0 ? (
              <EmptyState
                icon={
                  search
                    ? "mdi:magnify-remove-outline"
                    : "mdi:format-quote-close"
                }
                title={
                  search
                    ? "No se encontraron frases"
                    : "No hay frases registradas"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "No hay frases de selección por aplicación"
                }
              />
            ) : (
              <>
                <FrasesSeleccionAplicacionTable frases={list} search={search} />
                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      <FraseSeleccionAplicacionViewModal />
      <FraseSeleccionAplicacionFormModal />
      <ConfirmToggleSeleccionAplicacionModal />
    </div>
  );
};

export default FrasesSeleccionAplicacionListLayer;
